import { EDirtinessFormula, IOptions } from 'common/types/common.types';

export interface ITransactionFilterValus {
  period?: string;
  startDate?: string;
  endDate?: string;
}

export interface GatewayTypeOption {
  label: string | undefined;
  value: string;
}

export interface TransformedSelect {
  value: string;
  label: string;
}

export interface ILzTabFields {
  id?: number;
  name: string;
  okpo: string;
  inn: string;
  kpp?: string;
  businessAddress: string;
  actualAddress?: string;
  rs: string;
  executiveFullName?: string;
  executivePosition?: IOptions | null;
  executiveWorkPhone?: string;
  executiveAdditionalPhone?: string;
  executiveMobilePhone?: string;
  percent: string;
  individualPercent: string;
  loginGateway: string;
  passwordGateway: string;
  loginBinding: string;
  passwordBinding: string;
  sberPercent: string;
  commissionMode: IOptions;
  ogrn?: string;
  loginSberId: string;
  secretSberId: string;
  passportRecognizeEnabled: IOptions;
  innCheckEnabled: IOptions;
  innLzClientUpdateEnabled: IOptions;
  ogrnip?: string;
  smsConfirmation: IOptions;
  smsConfirmationMode: IOptions;
  smsUsers?: IOptions[];
  contactPersonFullName?: string;
  contactPersonMobilePhone?: string;
  contactPersonEmail?: string;
  twoFactorAuthEnabled: IOptions;
  individualPercentDate?: string;
  sberPercentDate?: string;
  commissionStartDate?: Date;
  gatewayType: IOptions;
  psaInfoTemplate?: string;
  dirtinessFormula: IOptions;
}

export interface ILzSettingsUpdate {
  passportRecognizeEnabled: boolean;
  innCheckEnabled: boolean;
  innLzClientUpdateEnabled: boolean;
  smsUsers?: number[];
  dirtinessFormula: EDirtinessFormula;
}

export interface ICommission {
  lzId: number;
  percentWrapper: {
    percent: number;
    sberPercent: number;
    startDate?: string;
  };
}

export interface ISmsSettingsUpdate {
  smsConfirmationMode: string;
  smsUsers?: number[];
  smsConfirmCode?: string;
}

export interface I2faSettingsUpdate {
  twoFactorAuthEnabled: boolean;
}

export enum GatewayType {
  DTB = 'DTB',
  SBER_API = 'SBER_API',
}

export interface UpdateGatewaySettings {
  gatewayType: GatewayType;
}

export interface SberIdSettingsUpdate {
  sberIdClientId: string;
  sberIdClientSecret: string;
  sberIdClientLogin: string;
  tlsClientCertPassword: string;
}

export interface SberIdInfo {
  sberIdClientId: string;
  sberIdClientSecret: string;
  sberIdIsConnected: boolean;
  lzId: number;
}

export interface SberIdSertificates {
  tlsClientTrust: File;
  tlsClientCert: File;
  edsPrivateKey: File;
  edsCertificate: File;
}

export interface ISberApiFields {
  clientId: string;
  clientSecret: string;
  sberIdClientLogin: string;
  tlsClientCertPassword: string;
  tlsClientTrust: string;
  clientEmail: string;
  clientFullName: string;
  clientOrgName: string;
  clientOrgUnit: string;
}

export interface ILoadedFile {
  name: string;
  sertName?: string;
  size?: number;
  file: File;
}

export interface IDocumentFields {
  documentId?: number | null;
  description: string;
  externalId: string;
  status: string | boolean;
  issuedAt: Date | string;
  expiresAt: Date | string;
  id: number | null;
}
